// language=GraphQL
export const ALL_CMS_CONFIGS_QUERY = `query Query($withContactBlockSettings: Boolean = false, $withSocialMediaSettings: Boolean = false, $withPrivacyPolicyPage: Boolean = false, $withPrivacyPolicyPageSeoSettings: Boolean = false, $withPrivacyPolicyPageSeoSettingsOgImage: Boolean = false, $withPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withPrivacyPolicyPageContentBlockAssignmentsBlock: Boolean = false, $withGtcPage: Boolean = false, $withGtcPageSeoSettings: Boolean = false, $withGtcPageSeoSettingsOgImage: Boolean = false, $withGtcPageContentBlockAssignments: Boolean = false, $withGtcPageContentBlockAssignmentsBlock: Boolean = false) {
  cmsConfigs: cmsConfigs {
    id
    contactBlockSettings @include(if: $withContactBlockSettings) {
      id
      slogan
      title
      text
      phonePrefix
      phone
      phone2Prefix
      phone2
      openingHours1
      openingHours2
      email
    }
    socialMediaSettings @include(if: $withSocialMediaSettings) {
      id
      facebookUrl
      instagramUrl
      linkedinUrl
    }
    privacyPolicyPage @include(if: $withPrivacyPolicyPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withPrivacyPolicyPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withPrivacyPolicyPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withPrivacyPolicyPageContentBlockAssignments) {
        id
        type
        block @include(if: $withPrivacyPolicyPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position

          }
        }
      }
    }
    gtcPage @include(if: $withGtcPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withGtcPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withGtcPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withGtcPageContentBlockAssignments) {
        id
        type
        block @include(if: $withGtcPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position

          }
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_CMS_CONFIG_QUERY = `query Query($id: ID!, $withContactBlockSettings: Boolean = false, $withSocialMediaSettings: Boolean = false, $withPrivacyPolicyPage: Boolean = false, $withPrivacyPolicyPageSeoSettings: Boolean = false, $withPrivacyPolicyPageSeoSettingsOgImage: Boolean = false, $withPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withPrivacyPolicyPageContentBlockAssignmentsBlock: Boolean = false, $withGtcPage: Boolean = false, $withGtcPageSeoSettings: Boolean = false, $withGtcPageSeoSettingsOgImage: Boolean = false, $withGtcPageContentBlockAssignments: Boolean = false, $withGtcPageContentBlockAssignmentsBlock: Boolean = false) {
  cmsConfig: cmsConfig(id: $id) {
    id
    contactBlockSettings @include(if: $withContactBlockSettings) {
      id
      slogan
      title
      text
      phonePrefix
      phone
      phone2Prefix
      phone2
      openingHours1
      openingHours2
      email
    }
    socialMediaSettings @include(if: $withSocialMediaSettings) {
      id
      facebookUrl
      instagramUrl
      linkedinUrl
    }
    privacyPolicyPage @include(if: $withPrivacyPolicyPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withPrivacyPolicyPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withPrivacyPolicyPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withPrivacyPolicyPageContentBlockAssignments) {
        id
        type
        block @include(if: $withPrivacyPolicyPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position

          }
        }
      }
    }
    gtcPage @include(if: $withGtcPage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withGtcPageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withGtcPageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withGtcPageContentBlockAssignments) {
        id
        type
        block @include(if: $withGtcPageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position

          }
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_CMS_CONFIG_MUTATION = `
  mutation Mutation($input: CreateCmsConfigInput, $withContactBlockSettings: Boolean = false, $withSocialMediaSettings: Boolean = false, $withPrivacyPolicyPage: Boolean = false, $withPrivacyPolicyPageSeoSettings: Boolean = false, $withPrivacyPolicyPageSeoSettingsOgImage: Boolean = false, $withPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withPrivacyPolicyPageContentBlockAssignmentsBlock: Boolean = false, $withGtcPage: Boolean = false, $withGtcPageSeoSettings: Boolean = false, $withGtcPageSeoSettingsOgImage: Boolean = false, $withGtcPageContentBlockAssignments: Boolean = false, $withGtcPageContentBlockAssignmentsBlock: Boolean = false) {
    cmsConfig: createCmsConfig(input: $input) {
      id
      contactBlockSettings @include(if: $withContactBlockSettings) {
        id
        slogan
        title
        text
        phonePrefix
        phone
        phone2Prefix
        phone2
        openingHours1
        openingHours2
        email
      }
      socialMediaSettings @include(if: $withSocialMediaSettings) {
        id
        facebookUrl
        instagramUrl
        linkedinUrl
      }
      privacyPolicyPage @include(if: $withPrivacyPolicyPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withPrivacyPolicyPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withPrivacyPolicyPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withPrivacyPolicyPageContentBlockAssignments) {
          id
          type
          block @include(if: $withPrivacyPolicyPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              email
              phonePrefix
              phone
              phone2Prefix
              phone2

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
            ... on CmsButtonBlock {
              id
              variant
              size
              position

            }
          }
        }
      }
      gtcPage @include(if: $withGtcPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withGtcPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withGtcPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withGtcPageContentBlockAssignments) {
          id
          type
          block @include(if: $withGtcPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              email
              phonePrefix
              phone
              phone2Prefix
              phone2

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
            ... on CmsButtonBlock {
              id
              variant
              size
              position

            }
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_CMS_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateCmsConfigInput, $withContactBlockSettings: Boolean = false, $withSocialMediaSettings: Boolean = false, $withPrivacyPolicyPage: Boolean = false, $withPrivacyPolicyPageSeoSettings: Boolean = false, $withPrivacyPolicyPageSeoSettingsOgImage: Boolean = false, $withPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withPrivacyPolicyPageContentBlockAssignmentsBlock: Boolean = false, $withGtcPage: Boolean = false, $withGtcPageSeoSettings: Boolean = false, $withGtcPageSeoSettingsOgImage: Boolean = false, $withGtcPageContentBlockAssignments: Boolean = false, $withGtcPageContentBlockAssignmentsBlock: Boolean = false) {
    cmsConfig: updateCmsConfig(input: $input) {
      id
      contactBlockSettings @include(if: $withContactBlockSettings) {
        id
        slogan
        title
        text
        phonePrefix
        phone
        phone2Prefix
        phone2
        openingHours1
        openingHours2
        email
      }
      socialMediaSettings @include(if: $withSocialMediaSettings) {
        id
        facebookUrl
        instagramUrl
        linkedinUrl
      }
      privacyPolicyPage @include(if: $withPrivacyPolicyPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withPrivacyPolicyPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withPrivacyPolicyPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withPrivacyPolicyPageContentBlockAssignments) {
          id
          type
          block @include(if: $withPrivacyPolicyPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              email
              phonePrefix
              phone
              phone2Prefix
              phone2

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
            ... on CmsButtonBlock {
              id
              variant
              size
              position

            }
          }
        }
      }
      gtcPage @include(if: $withGtcPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withGtcPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withGtcPageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withGtcPageContentBlockAssignments) {
          id
          type
          block @include(if: $withGtcPageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              email
              phonePrefix
              phone
              phone2Prefix
              phone2

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
            ... on CmsButtonBlock {
              id
              variant
              size
              position

            }
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_CMS_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteCmsConfigInput) {
    deleteCmsConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CMS_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteCmsConfigInput) {
    forceDeleteCmsConfig(input: $input) {
      success
    }
  }`
// language=GraphQL
export const CMS_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenantCms: Boolean = false) {
  groupedDependents: cmsConfigDependents(id: $id) {
    tenantCms @include(if: $withTenantCms) {
      id
    }
  }
}`
